module.exports = __webpack_public_path__ + "static/media/carrorama-starter.a1212e05.png";